/* eslint-disable no-warning-comments */
import * as React from 'react'
import {WebsiteCarbonBadge} from 'react-websitecarbon-badge'

import {makeEditable} from '@/common/utils'
import Buttons from '@/components/Buttons'
import Content from '@/components/Content'
import FooterColumn from '@/components/Footer/FooterColumn'
import FooterItem from '@/components/Footer/FooterItem'
import Social from '@/components/Footer/Social'
import {Grid} from '@/components/Grid'
import Image from '@/components/Image'
import {LanguageSwitcherFooter} from '@/components/LanguageSwitcherFooter'
import Link from '@/components/Link'
import RichText from '@/components/RichText'
const Footer = ({
  story,
  backgroundColors,
  logo,
  logoLink,
  content,
  newsletter,
  socials = [],
  columns = [],
  legals = [],
  copyrights = [],
  labels = [],
  co2Value = '0.12',
  co2Percentage = '89',
  showSwitchLanguage = false,
  _editable,
}) => {
  return (
    <section {...makeEditable(_editable)} className={backgroundColors.current}>
      <div className='relative m-0 w-full overflow-hidden rounded-b-[80px] bg-violet-600 pb-51 pt-20'>
        <Grid className='relative'>
          <div className='col-span-full md:col-span-8 lg:col-span-4'>
            <div className='flex justify-between gap-4'>
              <Link className='mb-14 block' link={logoLink}>
                <Image {...logo} ratio='9:2' sizes={{sm: '40', unit: 'px'}} />
              </Link>
              {showSwitchLanguage && <LanguageSwitcherFooter story={story} />}
            </div>
            <Content content={content} theme='light' />
            {newsletter &&
              newsletter.map(({_uid, heading, button, dataCollect}) => {
                return (
                  <div key={_uid} className='mt-6 flex flex-col gap-4 md:w-1/2 lg:w-full'>
                    <span className='body-m-bold text-white'>{heading}</span>
                    <Buttons buttons={button} buttonProps={{hasIcon: true}} />
                    {dataCollect && (
                      <RichText
                        className='[&>*>a]:text-white [&>*]:text-white'
                        richtext={dataCollect}
                      />
                    )}
                  </div>
                )
              })}
            <div className='mb-10 mt-14 hidden items-center justify-start  gap-4 lg:flex lg:flex-row'>
              {socials.length > 0 && (
                <ul className='w-fit justify-start gap-4 lg:flex lg:flex-row'>
                  {socials.map((social) => (
                    <Social key={social._uid} {...social} />
                  ))}
                </ul>
              )}
            </div>
          </div>
          {socials.length > 0 && (
            <ul className='lg: mb-10 mt-14 flex justify-start gap-4 md:order-none md:mb-0 md:w-fit md:flex-col lg:hidden'>
              {socials.map((social) => (
                <Social key={social._uid + 'mobile'} {...social} />
              ))}
            </ul>
          )}
          <div className='fit-content order-last col-span-full text-left md:absolute md:right-0 md:top-[180px] md:order-1 lg:absolute lg:bottom-16 lg:left-12 lg:right-auto lg:top-auto lg:col-span-3'>
            {co2Value && co2Percentage && (
              <WebsiteCarbonBadge co2={co2Value} percentage={co2Percentage} />
            )}
            {labels.length > 0 && (
              <div className='mt-8 flex gap-2 md:mt-2 lg:mt-8'>
                {labels.map((item) => (
                  <div key={item._uid} className='h-16 w-16'>
                    <Link link={item.link}>
                      <Image {...item.image} ratio='1:1' />
                    </Link>
                  </div>
                ))}
              </div>
            )}
          </div>
          {columns.length > 0 && (
            <div className='col-span-full md:order-3 md:col-start-3 md:mt-14 lg:col-start-7 lg:mt-19'>
              <div className='flex h-full flex-wrap gap-16 lg:justify-end'>
                {columns.map((column) => (
                  <FooterColumn key={column._uid} {...column} />
                ))}
              </div>
            </div>
          )}
        </Grid>
      </div>
      <div className='relative m-0 overflow-hidden bg-yellow-400 py-8'>
        <Grid>
          <div className='col-span-full flex w-full flex-col items-center justify-between text-center'>
            {legals.length > 0 && (
              <ul className='flex flex-col justify-start gap-2 md:flex-row md:gap-6'>
                {legals.map((legal) => (
                  <li key={legal._uid}>
                    <FooterItem {...legal} />
                  </li>
                ))}
              </ul>
            )}
            {copyrights.length > 0 && (
              <ul className='mt-4 flex flex-col justify-start gap-2'>
                {copyrights.map((copyright) => {
                  return (
                    <li key={copyright._uid} className='body-m-regular text-purple-400'>
                      {copyright.label &&
                        copyright.label.replace('[year]', new Date().getFullYear())}
                    </li>
                  )
                })}
              </ul>
            )}
          </div>
        </Grid>
      </div>
    </section>
  )
}

export default Footer
